import React from "react";
import Modal from "react-bootstrap/Modal";
import { useProductReview } from "../../Pregrine/ProductReview/useProductReview";
import { FaStar } from "react-icons/fa";
import styles from "./ProductReview.module.css";
const colors = {
  green: "#ffc107",
  grey: "#a9a9a9",
  black: "#111111",
};

const ProductReview = (props = {}) => {
  const {
    product,
    handleCloseReviewModal,
    showReviewModal,
    reviewMetaData,
    AddReview,
  } = props;

  const talonProps = useProductReview({
    product,
    AddReview,
    handleCloseReviewModal,
  });

  const {
    handleMouseLeave,
    handleClick,
    description,
    summary,
    setDescription,
    setSummary,
    descriptionError,
    summaryError,
    hoverValue,
    currentValue,
    handleSubmit,
    isValidDescription,
    isValidSummary,
  } = talonProps;

  return (
    <Modal show={showReviewModal} onHide={handleCloseReviewModal}>
      <Modal.Header
        closeButton
        style={{ color: "white", background: "black", padding: "5px 15px" }}
        className={styles.modalHeader}
      >
        <Modal.Title>
          <h5>Add Review</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {reviewMetaData &&
          reviewMetaData.productReviewRatingsMetadata &&
          reviewMetaData.productReviewRatingsMetadata.items &&
          reviewMetaData.productReviewRatingsMetadata.items.map(
            (attribute, idx) => {
              return (
                <div className="mb-3" key={idx}>
                  {attribute.name}

                  <div>
                    {attribute.values.map((item, index) => {
                      return (
                        <FaStar
                          key={index}
                          size={24}
                          onClick={() => handleClick(item, attribute.id)}
                          onMouseLeave={handleMouseLeave}
                          color={
                            hoverValue > index ||
                            (currentValue[attribute.id] &&
                              currentValue[attribute.id].value > index)
                              ? colors.green
                              : colors.grey
                          }
                          style={{
                            marginRight: 10,
                            cursor: "pointer",
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            }
          )}

        <div className="mb-3">
          <label for="exampleInputCategory" className="form-label">
            SUMMARY
          </label>
          <input
            onBlur={isValidSummary}
            type="text"
            className="form-control"
            id="exampleInputCategory"
            onChange={(e) => setSummary(e.target.value)}
          />
          <div className="row">
            <div
              style={{ color: "red" }}
              className="text-left text-small  color_red"
            >
              {summaryError}
            </div>
          </div>
        </div>
        <div className="mb-3">
          <label for="exampleInputCategory" className="form-label">
            DESCRIPTION
          </label>
          <input
            onBlur={isValidDescription}
            type="text"
            className="form-control"
            id="exampleInputCategory"
            onChange={(e) => setDescription(e.target.value)}
          />
          <div className="row">
            <div
              style={{ color: "red" }}
              className="text-left text-small  color_red"
            >
              {descriptionError}
            </div>
          </div>
        </div>
        <div className="text-center">
          <button
            style={{ background: " #42A9D6" }}
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Submit Your Review
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductReview;
